export const ENTRY = 'resetpassword';
export const BASE_PATH = '/auth/resetpassword';
export const BASE_PATHV2 = '/auth/resetpasswordv2';
export const PAGE_NAME = 'auth';
export const ROOT_KEY = 'resetPassword';
export const PAGE_TYPE = 'ResetPassword';
export const TITLE = 'Reset Password';
export const ROLLUP_BUCKET = 'Utility';
export const ANALYTICS_NAME = 'Reset Password';
